import { PlusOutlined } from '@ant-design/icons';
import CustomButton from 'components/RestActions/CustomButton';
import i18next from 'i18next';
import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { getCentresOfUser } from 'redux/centresOfUser/actions';
import CentreFilter from '../Form/CentreFilter';
import CentresOfUserTable from './CentresOfUserTable';

const CentresOfUserList = () => {
  const { push, location } = useHistory();

  const { id } = useParams();
  const dispatch = useDispatch();

  const retrieveList = useCallback(
    ({ filter = {}, isRefresh, keepFilter }) => {
      dispatch(
        getCentresOfUser({
          id,
          data: {
            ...filter,
            filter: {
              ...filter.filter,
            },
          },
          options: {
            isRefresh,
            isOrderBy: false,
            keepFilter,
          },
        }),
      );
    },
    [], // eslint-disable-line
  );

  useEffect(() => {
    retrieveList({
      filter: {
        limit: 10,
        offset: 0,
        orderBy: 'name',
      },
      isRefresh: true,
    });
  }, []); // eslint-disable-line

  const redirectAddMoreCentres = () => {
    push(`${location.pathname}/addMoreCentres`);
  };

  return (
    <div>
      <CentreFilter greyInput={false} retrieveList={retrieveList} />
      <div className="box-wrapper">
        <div className="flex-center-between mb-20">
          <div className="title-table">{i18next.t('centres.title')}</div>
          <CustomButton
            permissionKey="abilityChangeUserPermissions"
            isSkipSubscription
            action="isEdit"
            title="users.addMoreCentres"
            buttonProps={{
              icon: <PlusOutlined />,
              className: 'btn-second-primary',
            }}
            handleClick={redirectAddMoreCentres}
          />
        </div>
        <CentresOfUserTable retrieveList={retrieveList} />
      </div>
    </div>
  );
};

export default CentresOfUserList;
